<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Purchase Bond</v-toolbar-title>
    <v-spacer/>
    <span class="white--text caption font-weight-normal mr-3">Transacting Currency: {{Currency[0].CurrencyName}}</span>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>
<!-- ********************************************************************************************CREATE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="create">
    <v-row>
      <v-col cols="8">
        <v-card class="pt-3" elevation="12">
          <v-row class="ml-1 mr-1">
            <v-col class="pb-0">
              <v-select
                outlined dense @change="getBalances(BondPurchase.purchase.CustodialID); getAccounts(BondPurchase.purchase.CustodialID); BondPurchase.allocation = []"
                v-model="BondPurchase.purchase.CustodialID"
                :items="Custodians"
                item-text="CustodianName"
                item-value="CustodianID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Custodian"
              ></v-select>
              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    :value="balances.Available != null? (Number(balances.Available) - Number(BondPurchase.purchase.InstrumentValue)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    color="#2A353D"
                    label="Available Balance"
                    readonly class="pb-0"
                    placeholder="----"
                    :rules="[
                      v =>  v >= '0' || 'Available balance has been exceeded',
                    ]"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    :value="balances.Actual != null? Number(balances.Actual).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    color="#2A353D"
                    label="Actual Balance"
                    readonly
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-select
                outlined dense
                v-model="BondPurchase.purchase.InstrumentID"
                :items="Bonds"
                :item-text="item => item.BondNumber + ` - ` + allCounterparties.filter(a => a.CounterPartyID == item.IssuerID).map(a => a.CounterPartyName) + ` - ` + allBondInvestmentTypes.filter(a => a.BondInvestmentTypeID == item.BondInvestmentTypeID).map(a => a.BondInvestmentType)"
                item-value="BondID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Bond Number"
              ></v-select>
            </v-col>
            <v-col class="pb-0">
              <v-text-field
                :value="currentSystemDate.DayDate"
                label="Purchase Date"
                append-icon="mdi-calendar-month"
                readonly placeholder="--/--/--"
                dense outlined color="#2A353D"
                :rules="TextFieldRules"
              ></v-text-field>

              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="BondPurchase.purchase.ContactPerson"
                label="Contact"
                required
                placeholder="----"
                :rules="[
                  v => v ? (v && v.length <= 50) || 'field must be less than 50 characters' : null
                ]"
              ></v-text-field>
              <v-select
                outlined dense
                v-model="BondPurchase.purchase.SellerID"
                :items="allCounterparties.filter(a => a.IsSeller == true && a.CheckerID != 0 && a.RejectionID == 0)"
                item-text="CounterPartyName"
                item-value="CounterPartyID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Counterparty"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="ml-1 mr-1">
            <v-col class="pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="BondPurchase.purchase.InstrumentID != null? Number(getTotalValue(BondPurchase.purchase.InstrumentID)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                label="Total Bond Value"
                readonly
                placeholder="----" 
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
              <v-text-field
                @input="getCharges(BondPurchase.purchase.InstrumentValue); getTaxes(BondPurchase.purchase.InstrumentValue)"
                light dense outlined
                color="#2A353D"
                v-model="BondPurchase.purchase.InstrumentValue"
                label="Deal Value"
                required
                :rules="TextFieldRules"
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="BondPurchase.purchase.InstrumentID != null? Number(getUnitPrice(BondPurchase.purchase.InstrumentID)).toLocaleString(undefined, { minimumFractionDigits: 6, maximumFractionDigits: 6}) : ''"
                label="Bond Unit Price"
                placeholder="----"
                readonly
              ></v-text-field>
              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="BondPurchase.purchase.UnitPrice"
                label="Bond Price"
                required
                :rules="TextFieldRules"
                placeholder="----"
              ></v-text-field>
            </v-col>
            <v-col class="pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="BondPurchase.purchase.InstrumentID != null? Number(getBondQuantity(BondPurchase.purchase.InstrumentID)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                label="Total Bond Quantity"
                readonly
                placeholder="----"
              ></v-text-field>
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="BondPurchase.purchase.InstrumentValue != null && BondPurchase.purchase.UnitPrice != null ? Number(getDealQuantity(BondPurchase.purchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                label="Deal Quantity"
                readonly placeholder="----"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-data-table
          :headers="charges_headers"
          :fixed-header="true"
          :height="158"
          :items="ChargesApplied"
          disable-pagination
          hide-default-footer
          class="mb-2 elevation-12"
        >
          <template v-slot:top >
            <span class="d-flex flex-row">
              <span class="black--text caption font-weight-bold ml-2">Total Charges Applied:</span>
              <v-spacer/>
              <span v-if="BondPurchase.purchase.InstrumentValue != null" class="black--text caption font-weight-bold mr-2">{{Number(getTotalCharges()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            </span>
          </template>

          <template v-slot:item.Charge="{ item }">
            {{Number(item.Charge).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>

        </v-data-table>
        <v-data-table
          :headers="taxes_headers"
          :fixed-header="true"
          :height="158"
          :items="TaxesApplied"
          disable-pagination
          hide-default-footer
          class="mb-2 elevation-12"
        >
          <template v-slot:top >
            <span class="d-flex flex-row">
              <span class="black--text caption font-weight-bold ml-2">Total Taxes Applied:</span>
              <v-spacer/>
              <span v-if="BondPurchase.purchase.InstrumentValue != null" class="black--text caption font-weight-bold mr-2">{{Number(getTotalVAT()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            </span>
          </template>

          <template v-slot:item.Amount="{ item }">
            {{Number(item.Amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>
        
        </v-data-table>
      </v-col>
    </v-row>

    <v-data-table
      :headers="allocations_headers"
      :fixed-header="true"
      :items="BondPurchase.allocation"
      disable-pagination
      hide-default-footer dense
      class="elevation-12 my-allocations-table mt-3"
    >

      <template v-slot:top >
        <v-toolbar dense flat>
          <v-toolbar-title class="grey--text caption font-weight-normal">Allocations</v-toolbar-title>
          <v-spacer/>
          <v-btn class="text-right" @click="NewAllocation(BondPurchase.allocation)" x-small dark outlined fab color="#2A353D">
            <v-icon small >mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.AccountID="{ item }">
        <v-select
          @change="getCurrentAccountBalance(item)"
          @click="setActiveAllocation(item, index)"
          background-color="#ffffff00"
          v-model="item.AccountID"
          :items="Accounts"
          :menu-props="{ top: true, offsetY: true }"
          item-text="AccountName"
          item-value="AccountID"
          hide-details solo flat class="Account ma-0 pa-0 pt-5"
          placeholder="----" dense
          :rules="[
            v => !!v || 'field is required',
            v => BondPurchase.allocation.filter(a => a.FldBit02 == 0 && a.AccountID == item.AccountID).length < 2 || 'Account already selected'
          ]"
        ></v-select>
      </template>

      <template v-slot:item.OpeningBalance="{ item }">
        {{Number(item.OpeningBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.ClosingBalance="{ item }">
        {{Number(getClosingBalance(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.ChargeValue="{ item }">
        {{Number(getAllocationChargeValue(item, BondPurchase.purchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.UnitPrice="{ item }">
        {{Number(getAllocationUnitPrice(item, BondPurchase.purchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.Quantity="{ item }">
        {{Number(getAllocationQuantity(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template  v-slot:item.AllocationValue="{ item }">
        <v-text-field
          v-model="item.AllocationValue"
          label="----"
          :rules="[
            v => !!v || 'field is required!',
            v =>  v <= Number(item.OpeningBalance) || 'Over allocated',
          ]"
          single-line
          type="number"
        ></v-text-field>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon small @click="removeAllocation(item, BondPurchase.allocation)">mdi-close</v-icon>
      </template>

      <template v-slot:footer >
        <v-divider class="mt-0"/>
        <v-row class="ml-2 mr-2">
          <v-col class="pb-0 pt-7" cols="2">
          <v-text-field
            class="table-text-field"
            light dense
            :value="Number(getAllocatedValue(BondPurchase.allocation)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
            color="#2A353D"
            label="Allocated Value"
            readonly
            :rules="AllocatedValueRules"
            :prefix="Currency[0].CurrencySymbol"
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7">
          <v-text-field
            class="table-text-field"
            light dense
            :value="Number(getAllocatedUnits(BondPurchase.allocation)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
            color="#2A353D"
            label="Allocated Units"
            readonly
            :rules="AllocatedUnitsRules"
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7">
          <v-text-field
            class="table-text-field"
            light dense
            :value="BondPurchase.purchase.InstrumentValue != null ? Number(BondPurchase.purchase.InstrumentValue - getAllocatedValue(BondPurchase.allocation)).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0}) : 0"
            color="#2A353D"
            label="Remaining Amount"
            readonly
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7" cols="6">
            <div class="text-right mb-4 mt-4">
              <v-btn class="white--text mr-4" small color="#2A353D" @click="closeCreate()">close</v-btn>
              <v-btn class="white--text" small color="#2A353D" :disabled="!valid || loading == true" @click="createNew()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                submit
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </v-form>

<!-- ********************************************************************************************EDIT**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="edit" >
    <span class="d-flex flex-row mt-2">
      <span class="grey--text caption font-weight-normal">ID: <span class="subtitle-2">{{currentPurchase.DealNumber}}</span></span>
      <v-spacer/>
      <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentPurchase.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
      <span v-if="currentPurchase.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentPurchase.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
      <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentPurchase.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
    </span>
    <v-row>
      <v-col cols="8">
        <v-card class="pt-3" elevation="12">
          <v-row class="ml-1 mr-1">
            <v-col class="pb-0">
              <v-select
                outlined dense @change="getBalances(currentPurchase.CustodialID); getAccounts(currentPurchase.CustodialID); currentPurchase.allocations = []"
                v-model="currentPurchase.CustodialID"
                :items="Custodians"
                item-text="CustodianName"
                item-value="CustodianID"
                placeholder="----"
                :readonly="view"
                :rules="TextFieldRules"
                label="Custodian"
              ></v-select>
              <v-row>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    :value="balances.Available != null? (Number(balances.Available) - Number(currentPurchase.InstrumentValue)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    color="#2A353D"
                    label="Available Balance"
                    readonly class="pb-0"
                    placeholder="----"
                    :rules="[
                      v =>  v >= '0' || 'Available balance has been exceeded',
                    ]"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-text-field
                    light dense outlined
                    :value="balances.Actual != null? Number(balances.Actual).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                    color="#2A353D"
                    label="Actual Balance"
                    readonly
                    placeholder="----"
                    :prefix="Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-select
                outlined dense
                v-model="currentPurchase.InstrumentID"
                :items="Bonds"
                :item-text="item => item.BondNumber + ` - ` + allCounterparties.filter(a => a.CounterPartyID == item.IssuerID).map(a => a.CounterPartyName) + ` - ` + allBondInvestmentTypes.filter(a => a.BondInvestmentTypeID == item.BondInvestmentTypeID).map(a => a.BondInvestmentType)"
                item-value="BondID"
                placeholder="----"
                :readonly="view"
                :rules="TextFieldRules"
                label="Bond Number"
              ></v-select>
            </v-col>
            <v-col class="pb-0">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="currentPurchase.PurchaseDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="currentPurchase.PurchaseDate"
                  label="Purchase Date"
                  append-icon="mdi-calendar-month"
                  readonly placeholder="--/--/--"
                  dense outlined color="#2A353D"
                  :rules="TextFieldRules"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
                </template>
                <v-date-picker :readonly="view" color="#2A353D" v-model="currentPurchase.PurchaseDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
                <v-btn outlined small color="#2A353D" @click="$refs.menu.save(currentPurchase.PurchaseDate)">OK</v-btn>
                </v-date-picker>
              </v-menu>

              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="currentPurchase.ContactPerson"
                label="Contact"
                required
                :readonly="view"
                placeholder="----"
                :rules="[
                  v => v ? (v && v.length <= 50) || 'field must be less than 50 characters' : null
                ]"
              ></v-text-field>
              <v-select
                outlined dense
                v-model="currentPurchase.SellerID"
                :items="allCounterparties.filter(a => a.IsSeller == true && a.CheckerID != 0 && a.RejectionID == 0)"
                item-text="CounterPartyName"
                item-value="CounterPartyID"
                placeholder="----"
                :readonly="view"
                :rules="TextFieldRules"
                label="Counterparty"
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="ml-1 mr-1">
            <v-col class="pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="currentPurchase.InstrumentID != null? Number(getTotalValue(currentPurchase.InstrumentID)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                label="Total Bond Value"
                readonly
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
              <v-text-field
                @input="getCharges(currentPurchase.InstrumentValue); getTaxes(currentPurchase.InstrumentValue)"
                light dense outlined
                color="#2A353D"
                v-model="currentPurchase.InstrumentValue"
                label="Deal Value"
                required
                :readonly="view"
                :rules="TextFieldRules"
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>
            </v-col>
            <v-col class="pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="currentPurchase.InstrumentID != null? Number(getUnitPrice(currentPurchase.InstrumentID)).toLocaleString(undefined, { minimumFractionDigits: 6, maximumFractionDigits: 6}) : ''"
                label="Bond Unit Price"
                placeholder="----"
                readonly
              ></v-text-field>
              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="currentPurchase.UnitPrice"
                label="Bond Price"
                required
                :readonly="view"
                :rules="TextFieldRules"
                placeholder="----"
              ></v-text-field>
            </v-col>
            <v-col class="pt-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="currentPurchase.InstrumentID != null? Number(getBondQuantity(currentPurchase.InstrumentID)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                label="Total Bond Quantity"
                readonly
                placeholder="----"
              ></v-text-field>
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="currentPurchase.InstrumentValue != null && currentPurchase.UnitPrice != null ? Number(getDealQuantity(currentPurchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"
                label="Deal Quantity"
                readonly placeholder="----"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-data-table
          :headers="charges_headers"
          :fixed-header="true"
          :height="158"
          :items="ChargesApplied"
          disable-pagination
          hide-default-footer
          class="mb-2 elevation-12"
        >
          <template v-slot:top >
            <span class="d-flex flex-row">
              <span class="black--text caption font-weight-bold ml-2">Total Charges Applied:</span>
              <v-spacer/>
              <span v-if="currentPurchase.charges != null" class="black--text caption font-weight-bold mr-2">{{Number(getTotalCharges()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            </span>
          </template>

          <template v-slot:item.Charge="{ item }">
            {{Number(item.Charge).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>

        </v-data-table>
        <v-data-table
          :headers="taxes_headers"
          :fixed-header="true"
          :height="158"
          :items="TaxesApplied"
          disable-pagination
          hide-default-footer
          class="mb-2 elevation-12"
        >
          <template v-slot:top >
            <span class="d-flex flex-row">
              <span class="black--text caption font-weight-bold ml-2">Total Taxes Applied:</span>
              <v-spacer/>
              <span v-if="currentPurchase.charges != null" class="black--text caption font-weight-bold mr-2">{{Number(getTotalVAT()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            </span>
          </template>

          <template v-slot:item.Amount="{ item }">
            {{Number(item.Amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>
        
        </v-data-table>
      </v-col>
    </v-row>

    <v-data-table
      :headers="allocations_headers"
      :fixed-header="true"
      :items="currentPurchase.allocations"
      disable-pagination
      hide-default-footer dense
      class="elevation-12 my-allocations-table mt-3"
    >

      <template v-slot:top >
        <v-toolbar dense flat>
          <v-toolbar-title class="grey--text caption font-weight-normal">Allocations</v-toolbar-title>
          <v-spacer/>
          <v-btn class="text-right" @click="NewAllocation(currentPurchase.allocations)" x-small dark outlined fab color="#2A353D">
            <v-icon small >mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.AccountID="{ item }">
        <v-select
          @change="setActiveAllocation(item, index)"
          background-color="#ffffff00"
          v-model="item.AccountID"
          :items="Accounts"
          :menu-props="{ top: true, offsetY: true }"
          item-text="AccountName"
          item-value="AccountID"
          :readonly="view"
          hide-details solo flat class="Account ma-0 pa-0 pt-5"
          placeholder="----" dense
          :rules="[
            v => !!v || 'field is required',
            v => currentPurchase.allocations.filter(a => a.FldBit02 == 0 && a.AccountID == item.AccountID).length < 2 || 'Account already selected'
          ]"
        ></v-select>
      </template>

      <template v-slot:item.OpeningBalance="{ item }">
        {{Number(item.OpeningBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.ClosingBalance="{ item }">
        {{Number(getClosingBalance(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.ChargeValue="{ item }">
        {{Number(getAllocationChargeValue(item, currentPurchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.UnitPrice="{ item }">
        {{Number(getAllocationUnitPrice(item, currentPurchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template v-slot:item.Quantity="{ item }">
        {{Number(getAllocationQuantity(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
      </template>

      <template  v-slot:item.AllocationValue="{ item }">
        <v-text-field
          v-model="item.AllocationValue"
          label="----"
          :rules="[
            v => !!v || 'field is required!',
            v =>  v <= Number(item.OpeningBalance) || 'Over allocated',
          ]"
          single-line
          type="number"
        ></v-text-field>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon small @click="removeAllocation(item, currentPurchase.allocations)">mdi-close</v-icon>
      </template>

      <template v-slot:footer >
        <v-divider class="mt-0"/>
        <v-row class="ml-2 mr-2">
          <v-col class="pb-0 pt-7" cols="2">
          <v-text-field
            class="table-text-field"
            light dense
            :value="Number(getAllocatedValue(currentPurchase.allocations)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
            color="#2A353D"
            label="Allocated Value"
            readonly
            :rules="EditAllocatedValueRules"
            :prefix="Currency[0].CurrencySymbol"
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7">
          <v-text-field
            class="table-text-field"
            light dense
            :value="Number(getAllocatedUnits(currentPurchase.allocations)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
            color="#2A353D"
            label="Allocated Units"
            readonly
            :rules="EditAllocatedUnitsRules"
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7">
          <v-text-field
            class="table-text-field"
            light dense
            :value="currentPurchase.InstrumentValue != null ? Number(currentPurchase.InstrumentValue - getAllocatedValue(currentPurchase.allocations)).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0}) : 0"
            color="#2A353D"
            label="Remaining Amount"
            readonly
          ></v-text-field>
          </v-col>
          <v-col class="pb-0 pt-7" cols="6">
            <div class="text-right mb-4 mt-4">
              <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
              <v-btn v-if="!view" class="white--text ml-4" small color="#2A353D" :disabled="!valid || loading == true" @click="update()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                save
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </v-form>

<!-- ********************************************************************************************TABLE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    :headers="headers"
    :fixed-header="true"
    :items="confirmedPurchases ? Purchases : Purchases.filter(a => a.CheckerID === 0)"
    :search="search" v-if="!create &&  !edit"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >

      <v-dialog persistent v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="close()">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus('', false); close()">ok</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="reverseDialog" max-width="500px">
        <v-form flat ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="grey--text text-center">Deal Reversal</span>
            </v-card-title>

            <v-card-text>
              <span class="subtitle-1">{{reversal_description}}</span>

              <v-textarea
                class="mt-3"
                label="Reversal Reason"
                v-model="ReversalReason"
                outlined rows="6"
                row-height="15"
                :rules="TextFieldRules"
                placeholder="----"
              ></v-textarea>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="text-right mb-4">
                <v-btn class="white--text mr-3" small color="#2A353D" @click="reverseDialog = false">cancel</v-btn>
                <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="ReverseDeal()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  submit
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>          
        </v-form>
      </v-dialog>

      <v-container row>

        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true && DealerID > 0" v-show="confirmedPurchases" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-show="confirmedPurchases" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Bond Purchases.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Bond Purchases.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-show="confirmedPurchases" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
            CURRENCY<v-icon class="ml-1">mdi-cash-check</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item v-for="Currency in allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="Currency.CurrencyID" @click="mapCurrency(Currency); getCustodians()">

          <v-list-item-title>
            {{ Currency.CurrencyName }}
          </v-list-item-title>

          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-show="!confirmedPurchases" @click="confirmedPurchases = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0 && item.IsReversed == 0">rejected</v-chip>
      <v-chip outlined small color="error" v-if="item.IsReversed == 1">reversed</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0 && item.IsReversed == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0 && item.IsReversed == 0">confirmed</v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedPurchases && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="updateStatus(item, true)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedPurchases && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="reject(); setActivePurchase(item, index)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        v-show="confirmedPurchases && DealerID > 0"
        small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="setActivePurchase(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>edit</span>
      </v-btn>
      <v-btn
        small outlined
        :disabled="edit"
        @click="view = true; setActivePurchase(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
      <v-tooltip v-if="confirmedPurchases" top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-on="on"
            :disabled="showReverseBtn == true && item.CheckerID == 0 ? false : true"
            color="#2A353D" @click="setActivePurchase(item, index); initReversal(item)"
          >
          mdi-backup-restore
          </v-icon>
        </template>
        <span>reverse</span>
      </v-tooltip>
    </template>

    <template v-slot:item.CustodialID="{ item }">
      {{getCustodianName(item.CustodialID)}}
    </template>

    <template v-slot:item.AccountID="{ item }">
      {{getAccountName(item.AccountID)}}
    </template>

    <template v-slot:item.PurchaseDate="{ item }">
      {{ item.PurchaseDate | moment("DD MMM YYYY") }}
    </template> 

    <!-- <template v-slot:item.ValueDate="{ item }">
      {{ item.ValueDate | moment("DD MMM YYYY") }}
    </template>  -->

    <!-- <template v-slot:item.MakeDate="{ item }">
      {{ item.MakeDate | moment("DD MMMM YYYY") }}
    </template> -->

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import dealingService from '../services/dealing.service';
import transactionService from '../services/transaction.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  name: 'purchase_bond',

  data () {
    return {
      heading: "Sample PDF Generator",
      moreText: [
        "This is another few sentences of text to look at it.",
        "Just testing the paragraphs to see how they format.",
        "jsPDF likes arrays for sentences.",
        "Do paragraphs wrap properly?",
        "Yes, they do!",
        "What does it look like?",
        "Not bad at all."
      ],
      items: [
        { title: "Item 1", body: "I am item 1 body text" },
        { title: "Item 2", body: "I am item 2 body text" },
        { title: "Item 3", body: "I am item 3 body text" },
        { title: "Item 4", body: "I am item 4 body text" }
      ],
      confirmedPurchases: true,
      edit: false,
      view: false,
      create:false,
      message: '',
      menu: false,
      dialog: false,
      reverseDialog: false,
      ReversalReason: '',
      reversal_description: '',
      permitted: null,
      permitted_dialog: true,
      search: '',
      valid: true,
      loading: false,
      content: '',
      BondQuantity: '',
      currentAllocation: null,
      allocationIndex: -1,
      currentPurchase: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Ref Number',
          align: 'start',
          sortable: false,
          value: 'DealNumber'
        },
        { text: 'Custodian', value: 'CustodialID', sortable: true },
        { text: 'Purchase Date', value: 'PurchaseDate', sortable: true },
        // { text: 'Value Date', value: 'ValueDate', sortable: true },
        // { text: 'Deposit Method', value: 'DepositMethodID', sortable: true },
        // { text: 'Date Created', value: 'MakeDate', sortable: true },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      AllocatedValueRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(this.BondPurchase.purchase.InstrumentValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
      ],
      AllocatedUnitsRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(this.getDealQuantity(this.BondPurchase.purchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Quantity',
      ],
      EditAllocatedValueRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(this.currentPurchase.InstrumentValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
      ],
      EditAllocatedUnitsRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(this.getDealQuantity(this.currentPurchase)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Quantity',
      ],
      charges_headers: [
        { text: 'Charge Name', value: 'TransactionCharge', sortable: false },
        { text: 'Amt', value: 'Charge', sortable: false },
      ],
      ChargesApplied: [],
      taxes_headers: [
        { text: 'Charge', value: 'Charge', sortable: false },
        { text: 'Tax', value: 'Tax', sortable: false },
        { text: 'Amt', value: 'Amount', sortable: false },
      ],
      TaxesApplied: [],
      allocations_headers: [
        { text: 'Account Name', value: 'AccountID', sortable: false, width: 300 },
        { text: 'Amount', value: 'AllocationValue', sortable: false, width: 150  },
        { text: 'Charge', value: 'ChargeValue', sortable: false },
        { text: 'Units', value: 'Quantity', sortable: false },
        { text: 'Price', value: 'UnitPrice', sortable: false },
        { text: 'O/Balance', value: 'OpeningBalance', sortable: false },
        { text: 'C/Balance', value: 'ClosingBalance', sortable: false },
        { value: 'action', sortable: false }
      ],
      balances: {},
      CurrencyId: 0,
      Custodians: [],
      Accounts: [],
      DealQuantity: '',
      RejectionStatus: 0,
      BondPurchase: {
        purchase: {},
        allocation: [],
        charges: [],
        taxes: [],
      }
    }
  },

  computed: {
    ...mapGetters([
      "allBondPurchases",
      "allApplicationDefaults",
      "allCurrencies",
      "allAssetTypes",
      "allRejectionReasons",
      "allBonds",
      "allCounterparties",
      "allBondInvestmentTypes",
      "allDealers",
      "currentImage",
      "allUsers",
      "currentSystemDate",
      "allConfirmationSettings"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },
    Purchases() {
      return this.allBondPurchases.filter(a => a.CurrencyID == this.CurrencyId);
    },
    Currency() {
      return this.allCurrencies.filter(a => a.CurrencyID == this.CurrencyId && a.CheckerID != 0 && a.RejectionID == 0);
    },
    DealerID() {
      return this.allDealers.filter(a => a.SystemUserID == this.currentUser.SecurityUserID).map(a => a.DealerID).toLocaleString();
    },
    Bonds() {
      return this.allBonds.filter(a => a.CurrencyId == this.CurrencyId && a.CheckerID != 0 && a.RejectionID == 0);
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 102).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 102).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 102).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    showReverseBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 102).map(r => r.AllowReversal)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 102).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  TotalValue: function(newValue) {
    this.getTaxes(newValue);
    this.getCharges(newValue)
  },

  created () {
    this.CurrencyId = this.allApplicationDefaults[0].CurrencyID
    this.getCustodians();
  },

  methods: {
    ...mapActions([
      "createPurchase",
      "updatePurchase",
      "updatePurchaseStatus",
      "createReversal"
    ]),

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Bond Purchases", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Bond Purchases.pdf')
      }
    },

     async createNew() {
      this.message = '';

      await this.validate()

      if (this.valid == true) {
        this.loading = true;
        this.BondPurchase.purchase.MakerID = this.currentUser.SecurityUserID,
        this.BondPurchase.purchase.CheckerID = this.CheckerID,
        this.BondPurchase.purchase.LastUserID = this.currentUser.SecurityUserID,
        this.BondPurchase.purchase.PurchaseDate = this.currentSystemDate.DayDate,
        this.BondPurchase.purchase.SettlementDate = this.currentSystemDate.DayDate,
        this.BondPurchase.purchase.Quantity = this.DealQuantity,
        this.BondPurchase.purchase.CurrencyID = this.CurrencyId,
        this.BondPurchase.purchase.DealerID = this.DealerID,
        this.BondPurchase.purchase.AssetType = 1,
        this.BondPurchase.purchase.AllocationType = 1,
        this.BondPurchase.purchase.AvailAtTxn = Number(this.balances.Available) - Number(this.BondPurchase.purchase.InstrumentValue),
        this.BondPurchase.purchase.ActualAtTxn = this.balances.Actual,

        this.BondPurchase.charges = this.ChargesApplied,
        this.BondPurchase.taxes = this.TaxesApplied,

        this.createPurchase(this.BondPurchase)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newPurchase',
            data: response.data
          });
          this.loading = false;
          this.message = response.data.message
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        }) 
      }
    },

    async update() {
      this.message = '';

      await this.validate()

      if (this.valid == true) {
        this.loading = true;
        if(this.currentPurchase.CheckerID == 0){
          this.currentPurchase.AvailAtTxn = Number(this.balances.Available) - Number(this.currentPurchase.InstrumentValue),
          this.currentPurchase.ActualAtTxn = this.balances.Actual,
          this.currentPurchase.LastUserID = this.currentUser.SecurityUserID,
          this.currentPurchase.CheckDate = null,

          this.currentPurchase.charges = this.ChargesApplied,
          this.currentPurchase.taxes = this.TaxesApplied

          this.updatePurchase(this.currentPurchase)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updPurchase',
              data: this.currentPurchase
            });
            
            this.loading = false;
            this.message = response.data.message
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.loading = false;
          })
        } else {
          this.currentPurchase.AvailAtTxn = Number(this.balances.Available) - Number(this.currentPurchase.InstrumentValue),
          this.currentPurchase.ActualAtTxn = this.balances.Actual,
          this.currentPurchase.MakerID = this.currentUser.SecurityUserID,
          this.currentPurchase.LastUserID = this.currentUser.SecurityUserID,
          this.currentPurchase.CheckerID = 0,
          this.currentPurchase.CheckDate = null,
          this.currentPurchase.MakeDate = new Date(),
          this.currentPurchase.RejectionID = this.RejectionStatus,

          this.currentPurchase.charges = this.ChargesApplied,
          this.currentPurchase.taxes = this.TaxesApplied

          this.updatePurchase(this.currentPurchase)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updPurchase',
              data: this.currentPurchase
            });
            
            this.loading = false;
            this.message = response.data.message
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.loading = false;
          })
        }
      }
    },

    updateStatus(item, status) {
      this.message = '';
      this.loading = true;

      if(status == true){
        item.CheckerID = this.currentUser.SecurityUserID,
        item.LastUserID = this.currentUser.SecurityUserID,
        item.CheckDate = new Date(),
        item.updatedAt = new Date(),
        item.RejectionID = this.RejectionStatus,
        item.IsConfirmation = status,

        this.updatePurchaseStatus(item)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updPurchase',
            data: item
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        }) 
      } else {
        this.currentPurchase.CheckerID = this.currentUser.SecurityUserID,
        this.currentPurchase.LastUserID = this.currentUser.SecurityUserID,
        this.currentPurchase.CheckDate = new Date(),
        this.currentPurchase.updatedAt = new Date(),
        this.currentPurchase.RejectionID = this.RejectionStatus,
        this.currentPurchase.IsConfirmation = status,

        this.updatePurchaseStatus(this.currentPurchase)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updPurchase',
            data: this.currentPurchase
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })        
      }
    },

    getCustodians() {
      this.message = '';
      var data ={
        CurrencyID: this.CurrencyId,
      }
      dealingService.getCustodians(data.CurrencyID)
      .then(response => {
        this.Custodians = response.data
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getBalances(item) {
      this.message = '';
      var data ={
        CustodialID: item,
        EffectiveDate: this.currentSystemDate.DayDate,
        CurrencyID: this.CurrencyId
      }
      dealingService.getBalances(data.CustodialID, data)
      .then(response => {
        this.balances = response.data[0]
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getCurrentAccountBalance(item) {
      this.message = '';
      var data ={
        AccountID: item.AccountID,
        EffectiveDate: this.currentSystemDate.DayDate
      }

      if (item.AccountID != null) {
        transactionService.getAccountBalances(data.AccountID, data)
        .then(response => {
          item.OpeningBalance = response.data[0].Available
          return item.OpeningBalance
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getCharges(item) {
      var data = {
        ModuleID: 1,
        FunctionID: 102,
        CurrencyID: this.CurrencyId,
        Amount: item,
        Taxable: !!this.Taxable
      };

      if (item != null && data.Taxable != null) {
        dealingService.getTransactionCharges(data.ModuleID, data)
        .then(response => {
          this.ChargesApplied = response.data
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getTaxes(item) {
      var data = {
        ModuleID: 1,
        FunctionID: 102,
        CurrencyID: this.CurrencyId,
        Amount: item
      };

      if (item != null) {
        dealingService.getTransactionTaxes(data.ModuleID, data)
        .then(response => {
          this.TaxesApplied = response.data
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getClosingBalance(item) {
      item.ClosingBalance = item.OpeningBalance - (Number(item.AllocationValue) + Number(item.ChargeValue));
      return item.ClosingBalance
    },

    getAllocationUnitPrice(item, parent) {
      item.UnitPrice = parent.UnitPrice;
      return item.UnitPrice
    },

    getAllocationQuantity(item) {
      item.Quantity = item.AllocationValue / item.UnitPrice;
      return item.Quantity
    },

    getAllocationChargeValue(item, parent) {
      item.ChargeValue = (item.AllocationValue / parent.InstrumentValue) * this.getTotalCharges();
      return item.ChargeValue
    },

    getTotalCharges() {
      return this.ChargesApplied.map(a => Number(a.Charge)).reduce((a, b) => a + b, 0)
    },

    getTotalVAT() {
      return this.TaxesApplied.map(a => Number(a.Amount)).reduce((a, b) => a + b, 0)
    },

    mapCurrency(currency) {
      return this.CurrencyId = currency.CurrencyID
    },

    allowedDates: val => val <= new Date().toISOString().split('T')[0],

    getCustodianName(id) {
      return this.Custodians.filter(a => a.CustodianID === id).map(a => a.CustodianName).toLocaleString()
    },

    getBondDetails() {
      return this.allCounterparties.filter(a => a.CounterPartyID == this.Bonds.filter(Bonds => Bonds.BondID == this.BondPurchase.purchase.InstrumentID).map(Bonds => Bonds.IssuerID)).map(a => a.CounterPartyName) + ` - ` + this.allBondInvestmentTypes.filter(a => a.BondInvestmentTypeID == this.Bonds.filter(Bonds => Bonds.BondID == this.BondPurchase.purchase.InstrumentID).map(Bonds => Bonds.BondInvestmentTypeID)).map(a => a.BondInvestmentType)
    },

    getUnitPrice(item) {
      return this.Bonds.filter(a => a.BondID == item).map(a => a.UnitPrice)
    },

    getTotalValue(item) {
      return this.Bonds.filter(a => a.BondID == item).map(a => a.TotalValue)
    },

    getBondQuantity(item) {
      return this.Bonds.filter(a => a.BondID == item).map(a => a.TotalValue) / this.Bonds.filter(a => a.BondID == item).map(a => a.UnitPrice)
    },

    getDealQuantity(item) {
      this.DealQuantity = item.InstrumentValue / item.UnitPrice
      return this.DealQuantity
    },

    getAllocatedValue(item) {
      return item.map(i => Number(i.AllocationValue)).reduce((a, b) => a + b, 0);
    },

    getAllocatedUnits(item) {
      return item.map(i => Number(i.Quantity)).reduce((a, b) => a + b, 0);
    },

    getAccounts(item) {
      var data = {
        CustodialID: item,
        CurrencyID: this.CurrencyId,
        Taxable: null,
        Counter: 0
      }
      dealingService.getCustodianAccounts(data.CustodialID, data)
      .then(response => {
        this.Accounts = response.data
      })
    },

    NewAllocation(item) {
      item.push(
        {
          AccountID: null,
          OpeningBalance: '',
          AllocationValue: '',
          ChargeValue: '',
          Quantity: '',
          UnitPrice: '',
          ClosingBalance: ''
        }
      )
    },

    removeAllocation(item, parent) {
      const index = parent.findIndex(p => p.AccountID === item.AccountID);
      parent.splice(index, 1)
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedPurchases = false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.edit = false
      this.balances = {}
      this.ChargesApplied = []
      this.TaxesApplied = []
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.create = false
      this.balances = {}
      this.BondPurchase.allocation = [],
      this.BondPurchase.purchase = {},
      this.ChargesApplied = []
      this.TaxesApplied = []
    },

    reject () {
      this.dialog = true
    },

    initReversal(item){
      var data = {
        FunctionID: 102,
        EntryID: item.PurchaseID,
        ReversalDate: this.currentSystemDate.DayDate
      }
      
      dealingService.initReversal(data)
      .then(response => {
        if(response.data.validation[0].fnResultClass == 1){
          this.reverseDialog = true
          this.reversal_description = response.data.description[0][0].description
        } else {
          this.message = response.data.validation[0].fnResult
        }
      })
    },

    async ReverseDeal(){
      this.message = '';
      await this.validate()

      if (this.valid == true) {
        var data = {
          ReversalID: 0,
          FunctionID: 102,
          EntityID: this.currentPurchase.PurchaseID,
          ReversalReason: this.ReversalReason,
          ReversalDate: this.currentSystemDate.DayDate,
          MakerID: this.currentUser.SecurityUserID,
          CheckerID: 0,
          LastUserID: this.currentUser.SecurityUserID,
          RejectionID: 0,
        }

        this.createReversal(data)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'newReversal',
            data: response.data
          });
          
          this.message = response.data.message
          this.loading = false;
          this.reverseDialog = false;
          this.reversal_description = '';
          this.ReversalReason = '';
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    close () {
      this.dialog = false
      this.RejectionStatus = 0
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },

    async EditAllocation (item) {
      for (let i = 0; i < item.allocations.length; i++) {
        await this.getCurrentAccountBalance(item.allocations[i])
      }
      return item
    },

    async setActivePurchase (item, index) {
      const purchase = await this.EditAllocation(item)

      this.currentPurchase = purchase
      this.currentIndex = index

      this.getBalances(purchase.CustodialID)
      this.getAccounts(purchase.CustodialID)

      this.getCharges(purchase.InstrumentValue)
      this.getTaxes(purchase.InstrumentValue)
    },

    async setActiveAllocation (item, index) {
      await this.getCurrentAccountBalance(item)

      const alloc_index = this.currentPurchase.allocations.findIndex(a => a.PurchaseAllocationID === item.PurchaseAllocationID);

      this.currentPurchase.allocations.splice(alloc_index, 1, item);
      this.currentAllocation = item
      this.allocationIndex = index
    },
  },

  mounted () {
    UserService.isPurchaseBond().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedBondPurchases", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.edit {
  background-color: #DBEFFA;
}

.v-btn {
  outline: none
}

/* .v-select__selections input {
  display: none;
} */

.Account {
  width: 300px;
}

.my-allocations-table{
  table-layout : fixed;
}

.table-text-field{
  width: 170px;
}

.headline {
  color:white
}
</style>
